import React from 'react';
import PropTypes from 'prop-types';
import url from 'url';
import _ from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons/index';
import { Tooltip } from 'reactstrap';
import { JOBS_LIST_PAGE_SIZE } from '../../constants/general';
import { jobsListPeriods } from '../../constants/jobs';
import PaginationBaseComponent from './PaginationBaseComponent';
import UsersService from '../../services/UsersService';
import { appPath } from '../../constants';
import { labels } from '../../constants/text';

export default class JobsListBaseComponent extends PaginationBaseComponent {
  static propTypes = {
    userRoleId: PropTypes.number.isRequired,
    jobsList: PropTypes.array.isRequired,
    pastJobsWarning: PropTypes.bool.isRequired
  };

  state = {
    tooltipIsOpen: false
  };

  pageSize = JOBS_LIST_PAGE_SIZE;

  _setDataIsLoading = () => this.setState({ isLoading: true });

  _setDataLoaded = () => this.setState({ isLoading: false });

  getSelectedPeriod = () => {
    const { period } = url.parse(window.location.href, true).query;
    return period || jobsListPeriods.current.id;
  };

  sortJobsList = () => {
    const { jobsList } = this.props;
    const { period } = this.state;
    const isDescending = period === jobsListPeriods.past.id;
    const order = isDescending ? 'desc' : 'asc';
    return _.orderBy(jobsList, ['start_date', 'id'], [order]);
  };

  switchTab = e => {
    const period = e.currentTarget.id;
    this.setState({
      period,
      statuses: [],
      get_not_completed: false
    }, () => this._loadData(0));
  };

  toggleTooltip = () => {
    this.setState(prevState => ({
      tooltipIsOpen: !prevState.tooltipIsOpen
    }));
  };

  showNotApprovedJobs = e => {
    e.stopPropagation();
    this.setState({
      period: jobsListPeriods.past.id,
      statuses: [],
      get_not_completed: true
    }, () => this._loadData(0));
  };

  cancelJob = jobId => {
    const { cancelJobAction } = this.props;
    const userRole = UsersService.getUserRole();
    cancelJobAction(jobId, userRole).then(() => this._loadData(this.state.activePage));
  };

  navigateToCreateJob = () => {
    this.props.history.push(`/${appPath}/newjob`);
  };

  renderTabs = () => {
    const { period } = this.state;
    const { pastJobsWarning } = this.props;
    return (
      <React.Fragment>
        <button
          id={jobsListPeriods.current.id}
          className={period === jobsListPeriods.current.id ? 'tab active' : 'tab'}
          onClick={this.switchTab}
        >{jobsListPeriods.current.ui}</button>
        <button
          id={jobsListPeriods.past.id}
          className={period === jobsListPeriods.past.id ? 'tab active' : 'tab'}
          onClick={this.switchTab}
        >
          {jobsListPeriods.past.ui}
          {` `}
          { pastJobsWarning && (
            <React.Fragment>
              <span
                className='icon-wrapper exclamation-icon'
                id='exclamationTooltip'
                onClick={this.showNotApprovedJobs}
              >
                <FontAwesomeIcon icon={faExclamationCircle} />
              </span>
              <Tooltip placement='top' isOpen={this.state.tooltipIsOpen} target='exclamationTooltip' toggle={this.toggleTooltip}>
                { labels.needApproveLabel }
              </Tooltip>
            </React.Fragment>
          )}
        </button>
      </React.Fragment>
    );
  };

  render () {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/common/JobsListBaseComponent.js